class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/bulk-assign`;
    }
    /**
     * Creates or updates the list of extensions to be recorded.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/call-recording/bulk-assign
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyInfo
     */
    async post(bulkAccountCallRecordingsResource, restRequestConfig) {
        const r = await this.rc.post(this.path(), bulkAccountCallRecordingsResource, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
